import {
  INT_KEYS,
  MIL_KEYS,
  PERC_KEYS,
  COMMA_KEYS,
  COMMA_OPTIONS,
  THOUSANDS_KEYS,
  INITIAL_PORTCO_DATA
} from './constants';
import {
  roundToDecimal,
  calculateDivision,
  sortDataByQuarter
} from './helpers';
import { Row, QuarterKey, PortCoKeys, RowWithDate } from '../types';

export const transformToQuarterData = <T extends RowWithDate>(
  data: readonly T[]
): {
  rows: Row[];
  labels: QuarterKey[];
  quarterData: Record<QuarterKey, RowWithDate>;
} => {
  const sortedData = sortDataByQuarter([...data]);
  const quarterData: Record<QuarterKey, RowWithDate> = {};

  const labels: QuarterKey[] = sortedData.map(row => {
    quarterData[row.QUARTER.toLowerCase().replaceAll(' ', '_') as QuarterKey] =
      { QUARTER: row.QUARTER, PERIOD_END: row.PERIOD_END };

    return row.QUARTER.toLowerCase().replaceAll(' ', '_') as QuarterKey;
  });

  const rows = Object.keys(PortCoKeys).map(rowObj => {
    const row: Row = {
      ...structuredClone(INITIAL_PORTCO_DATA[rowObj as PortCoKeys])
    };

    sortedData
      // TODO: Remove manual mapping when fields are returned from BE
      .map((d: T, index: number) => ({
        ...d,
        [PortCoKeys.YOY_ARR_GROWTH]:
          // d[PortCoKeys.YOY_ARR_GROWTH] ||
          calculateDivision(
            Number(d[PortCoKeys.ARR_EOP]) || 0,
            Number(sortedData[index - 4]?.[PortCoKeys.ARR_EOP] || 0),
            true,
            true
          )
            ? roundToDecimal(
                calculateDivision(
                  Number(d[PortCoKeys.ARR_EOP]) || 0,
                  Number(sortedData[index - 4]?.[PortCoKeys.ARR_EOP] || 0),
                  true,
                  true
                )! / 100,
                5
              )
            : '',
        [PortCoKeys.ANNUALIZED_REVENUE]:
          // d[PortCoKeys.ANNUALIZED_REVENUE] ||
          Number(d[PortCoKeys.ARR_EOP] || 0) ||
          Number(d[PortCoKeys.REVENUE_TOTAL] || 0) * 4 ||
          '',
        [PortCoKeys['MARGIN_FCF.1']]:
          // d[PortCoKeys['MARGIN_FCF.1']] ||
          d[PortCoKeys.MARGIN_FCF] || '',
        [PortCoKeys['MARGIN_GROSSPROFIT.1']]:
          // d[PortCoKeys['MARGIN_GROSSPROFIT.1']] ||
          d[PortCoKeys.MARGIN_GROSSPROFIT] || '',
        [PortCoKeys.RULE_OF_40]:
          Number(
            // d[PortCoKeys.YOY_ARR_GROWTH] ||
            calculateDivision(
              Number(d[PortCoKeys.ARR_EOP]) || 0,
              Number(sortedData[index - 4]?.[PortCoKeys.ARR_EOP] || 0),
              true,
              true
            )
              ? roundToDecimal(
                  calculateDivision(
                    Number(d[PortCoKeys.ARR_EOP]) || 0,
                    Number(sortedData[index - 4]?.[PortCoKeys.ARR_EOP] || 0),
                    true,
                    true
                  )! / 100,
                  5
                )
              : ''
          ) + Number(d[PortCoKeys.MARGIN_FCF] || 0) || '',
        [PortCoKeys.ARR_PER_FTE]:
          d[PortCoKeys.ARR_PER_FTE] !== null &&
          d[PortCoKeys.ARR_PER_FTE] !== undefined
            ? d[PortCoKeys.ARR_PER_FTE]
            : (Number(d[PortCoKeys.ARR_EOP] || 0) ||
                Number(d[PortCoKeys.REVENUE_TOTAL] || 0)) &&
              Number(d[PortCoKeys.EMPLOYEES_TOTAL] || 0) &&
              calculateDivision(
                Number(
                  Number(d[PortCoKeys.ARR_EOP] || 0) ||
                    Number(d[PortCoKeys.REVENUE_TOTAL] || 0) * 4 ||
                    0
                ),
                Number(d[PortCoKeys.EMPLOYEES_TOTAL] || 0),
                false,
                false
              )
            ? roundToDecimal(
                calculateDivision(
                  Number(
                    Number(d[PortCoKeys.ARR_EOP] || 0) ||
                      Number(d[PortCoKeys.REVENUE_TOTAL] || 0) * 4 ||
                      0
                  ),
                  Number(d[PortCoKeys.EMPLOYEES_TOTAL] || 0),
                  false,
                  false
                )!,
                5
              )
            : ''
      }))
      .forEach(dataObj => {
        const val = dataObj[rowObj];
        const quarterKey = dataObj.QUARTER.toLowerCase().replaceAll(' ', '_');
        const label = quarterKey as QuarterKey;

        row[label] =
          val === null || val === undefined || val === ''
            ? ''
            : MIL_KEYS.includes(rowObj as PortCoKeys)
            ? roundToDecimal(Number(val) / 1000000)
            : THOUSANDS_KEYS.includes(rowObj as PortCoKeys)
            ? roundToDecimal(Number(val) / 1000)
            : PERC_KEYS.includes(rowObj as PortCoKeys)
            ? roundToDecimal(Number(val) * 100)
            : INT_KEYS.includes(rowObj as PortCoKeys) &&
              COMMA_KEYS.includes(rowObj as PortCoKeys)
            ? val.toLocaleString()
            : COMMA_KEYS.includes(rowObj as PortCoKeys)
            ? val.toLocaleString('en-US', COMMA_OPTIONS)
            : INT_KEYS.includes(rowObj as PortCoKeys)
            ? roundToDecimal(Number(val), 0)
            : roundToDecimal(Number(val));
      });

    return row;
  });

  return { rows, labels, quarterData };
};
